// Module
var code = "<div ng-if=\"overlays||baselayers\" ng-controller=\"MapMenuController\"> <div> <h3>Kartenoptionen</h3> <div con10t-map-menu-overlays overlays=\"overlays\"></div> <div con10t-map-menu-baselayer baselayers=\"baselayers\"></div> </div> <div con10t-map-zoomcontrol id=\"ar-map-zoomcontrol\" style=\"left:19%\"></div> </div>";
// Exports
module.exports = code;